import { gql } from 'graphql-request'

export const ASSISTANT_TASKS_QUERY = gql`
  query AssistantTasks($now: timestamptz!) {
    assistant_tasks(
      where: {
        completed_at: { _is_null: true }
        dismissed_at: { _is_null: true }
        visible_from: { _lte: $now }
      }
      order_by: [{ created_at: desc }]
    ) {
      id
      project_id
      kind
      source
      title
      reason
      meta
      action_label_override
      created_at
      updated_at
      visible_from
      target_time
      dismissed_at
      completed_at
      project {
        id
        project_type
        primary_signatory_client {
          first_name
          last_name
        }
      }
    }
  }
`

// Reschedule: writes target_time only. The task stays visible; its derived
// bucket recomputes from the new deadline, which moves it between the
// Urgent / Cette semaine / En attente tabs. visible_from is never touched.
export const RESCHEDULE_TASK_MUTATION = gql`
  mutation RescheduleAssistantTask($id: uuid!, $chosenDate: timestamptz!) {
    update_assistant_tasks_by_pk(
      pk_columns: { id: $id }
      _set: { target_time: $chosenDate }
    ) {
      id
      target_time
    }
  }
`

// Dismiss — one-way. Tasks with dismissed_at set are filtered out of every
// user-facing view; there is no reactivate affordance.
export const DISMISS_TASK_MUTATION = gql`
  mutation DismissAssistantTask($id: uuid!, $dismissedAt: timestamptz!) {
    update_assistant_tasks_by_pk(
      pk_columns: { id: $id }
      _set: { dismissed_at: $dismissedAt }
    ) {
      id
      dismissed_at
    }
  }
`

// Complete — manual-task validate. Auto tasks are completed by the engine
// (predicate-driven), never through this mutation from the UI.
export const COMPLETE_TASK_MUTATION = gql`
  mutation CompleteTask($id: uuid!) {
    update_assistant_tasks_by_pk(
      pk_columns: { id: $id }
      _set: { completed_at: "now()" }
    ) {
      id
      completed_at
    }
  }
`

// Manual task creation — one date captures both visibility and deadline.
// target_time = chosenDate; visible_from = min(now, chosenDate).
export const INSERT_MANUAL_TASK_MUTATION = gql`
  mutation InsertManualTask(
    $title: String!
    $reason: String
    $meta: String
    $projectId: Int
    $visibleFrom: timestamptz!
    $targetTime: timestamptz!
  ) {
    insert_assistant_tasks_one(
      object: {
        title: $title
        reason: $reason
        meta: $meta
        project_id: $projectId
        kind: "manual"
        visible_from: $visibleFrom
        target_time: $targetTime
      }
    ) {
      id
      project_id
      kind
      source
      title
      reason
      meta
      action_label_override
      created_at
      updated_at
      visible_from
      target_time
      dismissed_at
      completed_at
      project {
        id
        project_type
        primary_signatory_client {
          first_name
          last_name
        }
      }
    }
  }
`
